import React from 'react';
import QuoteRequestForm, { BrochureBtn, VideoButton, ImgRender } from '../../BFComponents';

const CanonIpf780 = () => {
    return (
        <div className="container">
            <ImgRender image={"prograf-banner.jpg"} width={100} />
            <div className="row">
                <div className="col-md-6">
                    <ImgRender image={"ipf780.jpg"} width={100} />
                </div>
                <div className="col-md-6 p-4">
                    <ImgRender image={"ipf780.svg"} width={50} />
                    <h4>Simplify your workflow with
                    the 36” imagePROGRAF iPF785/
                    iPF780 and 24” iPF685/iPF680
Large-Format Printers</h4>
                    <p>These printers aim to boost
                    productivity while staying true to
                    some of their great legacy features.
                    Faster draft printing, increased
                    ink tank sizes, a magenta ink, and
                    software enhancements help make
                    printing easier and more convenient
                    than ever before, while the sub-inktank system, large on-board hard
                    drive,* and user-friendly assembly
                    all carry over to help ensure the
                    printer operates seamlessly into
your workflow..</p>

                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    <QuoteRequestForm source={window.location} />
                    <BrochureBtn brochure={"Canon imagePROGRAF iPF780.pdf"} />
                    <VideoButton id={"V1k4t47qOaEM"} />
                    <h4 className="ipfblueheader">FEATURES</h4>
                    <h5 className="ipforangeheader">High Productivity</h5>
                    <ul>
                        <li><strong>Print speeds</strong> are capable of producing a 24” x 36” Arch D-sized print
in approximately <strong>21 seconds</strong> in Economy Mode.</li>
                    </ul>
                    <h5 className="ipforangeheader">Large-capacity Ink Tanks</h5>

                    <ul>
                        <li>In addition to the 130 ml ink tanks, 300 ml ink tanks are compatible
                        with these solutions to <strong>help lower ink costs</strong> per print. Users also
have the option to mix and match ink tank sizes.</li>
                    </ul>
                    <h5 className="ipforangeheader">Reformulated Magenta Ink</h5>
                    <ul>
                        <li>Magenta ink helps improve the <strong>clarity and vibrancy</strong> of red fine lines,
text, and images</li>
                    </ul>
                    <h5 className="ipforangeheader">Sub-ink-tank System</h5>
                    <ul>
                        <li>Allows for <strong>ink tanks to be changed on the fly</strong>, without interrupting
the print job.</li>
                    </ul>

                    <h5 className="ipforangeheader">Software</h5>
                    <ul>
                        <li><strong>Canon workflow solutions</strong> include a mobile printing app,†† Direct
                        Print & Share, Status Monitor, Media Configuration Tool, Print
Plug-in for Microsoft Office, and more!</li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <h4 className="ipfblueheader">ADVANTAGES</h4>

                    <h5 className="ipforangeheader">SPEED</h5>
                    The iPF785/780 and iPF685/680 printers offer speeds
that have never been seen before on previous Canon
imagePROGRAF large-format printer models. In their fastest
mode (Economy Mode), the 36” iPF785/780 printers are
capable of reproducing 24” x 36” Arch D-sized prints in
approximately 21 seconds! The 24” iPF685/680 printers
can reproduce 24” x 36” Arch D-sized prints in approximately
25 seconds!
                    <h5 className="ipforangeheader">INK</h5>
                    Magenta ink helps improve the clarity and vibrancy of red
fine lines, text, and images in many technical and poster
prints. The color gamut has also increased in the orange
to red areas when compared to previous models. From a
productivity perspective, the printers now support ink tank
sizes of 300 ml to help lower the cost per print. The included
sub-ink-tank system allows the use of all the ink that’s
available in a tank before replacement is needed. It also
allows for on-the-fly swapping of ink tanks should one run
out in the middle of a print job.
                    <h5 className="ipforangeheader">ADDED FEATURES</h5>
                    All four models include the flat stacker/basket previously
seen on only the iPF76x Series models. This feature provides
the capability to neatly stack up to twenty 24” x 36” plain
paper prints. It can also be enabled or disabled based on
user preference. <br /><br /> Also included on the iPF785 and iPF685 models is a 320 GB
hard drive, allowing for the storage of up to 500 print jobs,
the creation of individual user mail boxes, and improved
print processing while falling under U.S. Department of
Defense requirements (DoD 5220.22-M).
                </div>
                <div className="col-md-4">
                    <h5 className="ipforangeheader">SOFTWARE</h5>
                    Enhancements to the line-up of imagePROGRAF software
solutions will help improve printing workflow and
management.
<br /><br /><strong>imagePROGRAF Print Utility<br /></strong>

For the first time, a mobile app has been made available for
imagePROGRAF large-format printers. This iOS-based app
allows users to print PDF files from their iPad®.
<br /><br /><strong>Direct Print & Share<br /></strong>
Canon’s cloud portal solution has been updated to support
additional WebDAV-compliant cloud servers, along with
HP-GL/2 data to allow for the printing of JPG, TIFF, PDF,
and HP-GL/2 files from almost anywhere in the world!
And a new “Shortcut Print” button has been added, too.
With this additional functionality, hot folders can be
created and set up on your desktop. You can drag and drop
your files into the folders and your jobs will begin printing
automatically! Multiple folders can be set up for shortcut
printing, each with their own print settings for custom
printing applications!
<br /><br /><strong>PosterArtist<br /></strong>

Canon’s optional, added-value, poster-creation software has
been upgraded for use with Direct Print & Share. Various
software improvements with variable data printing and file
structure have also been made for easier use.
<br /><br /><strong>Status Monitor<br /></strong>

This software can be used with all imagePROGRAF
devices and has been updated to include an "ink purchase
notification" function. This notifies users when their ink
supply is low and a purchase is needed.
                </div>
            </div>

        </div >
    )
}

export default CanonIpf780;